import { satisfies } from 'semver'

function jsBridge(callback) {
	if (window.WebViewJavascriptBridge) {
		return callback(WebViewJavascriptBridge);
   }else{
	   document.addEventListener('WebViewJavascriptBridgeReady', function() {
		   callback(WebViewJavascriptBridge)
	   },false);
   if (window.WVJBCallbacks) {
		return window.WVJBCallbacks.push(callback);
   }
   window.WVJBCallbacks = [callback];
   var WVJBIframe = document.createElement('iframe');
   WVJBIframe.style.display = 'none';
   WVJBIframe.src = 'https://__bridge_loaded__';
   document.documentElement.appendChild(WVJBIframe);
   setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)}
}

interface appFrom {
    os: string;
    appVersionCode: string;
}

interface appLimitVersion {
    android_limit_version: string;
    ios_limit_version: string;
}

const judgeAppVersionCode = async(props: appLimitVersion ): Promise<boolean> => {

    const {
        android_limit_version = '4.30.0',
        ios_limit_version = '4.30.0',
    } = props;

    let app_from: appFrom  = {
        os: '',
        appVersionCode: ''
    };

    const osData = await new Promise((resolve,reject) =>{
            jsBridge(function(bridge: any) {
                bridge.callHandler('FromApp', {},
                    function responseCallback(responseData) {
                        resolve(responseData)
                    }
                )
            })
      })

      app_from = osData as appFrom;

      switch (app_from.os) {
          case 'android':

            return satisfies(app_from.appVersionCode, `>=${android_limit_version}`);

        case 'iOS':

            return satisfies(app_from.appVersionCode, `>=${ios_limit_version}`);

          default:
              return false;
      }

}

export default judgeAppVersionCode

export { jsBridge }